import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ApiModuleConfig} from '@tisa-group/cdk/models';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {LOCAL_STORAGE} from '@ng-web-apis/common';
import {
  TISA_MEDIA_LIBRARY_TOKEN,
  TISA_MEDIA_LIBRARY_URL,
} from './tisa-media-library.providers';
import {TisaMediaLibraryHttpService} from './tisa-media-library-http.service';
import {UNDEFINED_MEDIA_LIBRARY_BASE_URL} from './tisa-media-library.errors';
import {FileService} from './file/file.service';
import {SubdirectoryService} from './subdirectory/subdirectory.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    TisaMediaLibraryHttpService,
    FileService,
    SubdirectoryService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class TisaMediaLibraryModule {
  static forRoot(config: ApiModuleConfig): ModuleWithProviders<TisaMediaLibraryModule> {
    if (!config.api) throw UNDEFINED_MEDIA_LIBRARY_BASE_URL;

    return {
      ngModule: TisaMediaLibraryModule,
      providers: [
        {
          provide: TISA_MEDIA_LIBRARY_URL,
          useValue: config.api,
        },
        {
          provide: TISA_MEDIA_LIBRARY_TOKEN,
          useFactory: (localStorage: Storage) => {
            return () => localStorage.getItem('TISA_TOKEN');
          },
          deps: [LOCAL_STORAGE],
        },
      ],
    };
  }
}
